import { render, staticRenderFns } from "./ConfigForm.vue?vue&type=template&id=34936623&scoped=true"
import script from "./ConfigForm.vue?vue&type=script&lang=js"
export * from "./ConfigForm.vue?vue&type=script&lang=js"
import style0 from "./ConfigForm.vue?vue&type=style&index=0&id=34936623&prod&lang=scss&scoped=true"
import style1 from "./ConfigForm.vue?vue&type=style&index=1&id=34936623&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34936623",
  null
  
)

export default component.exports